let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8aKVT")).then(() => parcelRequire('2epwS'));